import apiClient from "./axiosConfig";

export interface SubscriptionStatus {
  isActive: boolean;
  neverSubscribed: boolean;
  message: string;
  subscription?: {
    source: string;
    startedAt: string;
    expiresAt: string;
  };
}

export const fetchSubscriptionStatus = async (): Promise<SubscriptionStatus> => {
  const { data } = await apiClient.get("/api/subscription/me");
  return data;
};

export const createSubscriptionInvoice = async (userId: number) => {
  const { data } = await apiClient.post("/api/payments/subscribe", { userId });
  return data; // { invoice_link }
};
